import {
  Box,
  Button,
  Chip,
  IconButton,
  Modal,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  Link,
  Divider,
} from "@mui/material";
import { useEffect, useState } from "react";
import makeStyles from "@mui/styles/makeStyles";
import DoneIcon from "@mui/icons-material/Done";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import SuggestedReviewer from "./SuggestedReviewer";
import { useDispatch } from "react-redux";
import {
  setCanEdit,
  setReferee,
  setRefereeStatus,
} from "../../../../store/refereeSlice";
import { useHistory } from "react-router";
import service from "../../Helpers/gifservices";
import { useLoading } from "../../../../providers/loadingProvider";
import { checkRefereeStatus } from "../../Helpers/common";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing(3),
    overflowX: "auto",
  },
  table: {
    minWidth: 650,
  },
  tableCell: {
    fontWeight: 600,
    color: "#4B4B4B",
  },
  secoundTypography: {
    color: "#0A46F0",
    fontWeight: 600,
    marginRight: 20,
  },
  inProgressChip: {
    color: theme.palette.gif.yellow.dark,
    backgroundColor: theme.palette.gif.yellow.color,
    fontWeight: 600,
  },
  doneChip: {
    backgroundColor: theme.palette.gif.green.color,
    color: "white",
    fontWeight: 600,
  },
  addButton: {
    "&:hover": {
      backgroundColor: theme.palette.gif.yellow.hover,
    },
    color: theme.palette.gif.yellow.dark,
    backgroundColor: theme.palette.gif.yellow.color,
  },
  proposalName: {
    fontWeight: 500,
    cursor: "pointer",
  },
}));

const checkProposalRefereeStatus = (proposalReferee) => {
  if (
    proposalReferee.detailedEvaluation === null ||
    proposalReferee.detailedEvaluation === undefined ||
    proposalReferee.detailedEvaluation === ""
  )
    return false;
  if (
    proposalReferee.modeOfCooperationBetweenTheTeams === null ||
    proposalReferee.modeOfCooperationBetweenTheTeams === undefined ||
    proposalReferee.modeOfCooperationBetweenTheTeams === "" ||
    proposalReferee.modeOfCooperationBetweenTheTeams === 0
  )
    return false;
  if (
    proposalReferee.originalityInnovation === null ||
    proposalReferee.originalityInnovation === undefined ||
    proposalReferee.originalityInnovation === "" ||
    proposalReferee.originalityInnovation === 0
  )
    return false;
  if (
    proposalReferee.suitabilityOfInvestigatorsScientific === null ||
    proposalReferee.suitabilityOfInvestigatorsScientific === undefined ||
    proposalReferee.suitabilityOfInvestigatorsScientific === "" ||
    proposalReferee.suitabilityOfInvestigatorsScientific === 0
  )
    return false;
  if (
    proposalReferee.adequacyOfMethods === null ||
    proposalReferee.adequacyOfMethods === undefined ||
    proposalReferee.adequacyOfMethods === "" ||
    proposalReferee.adequacyOfMethods === 0
  )
    return false;
  if (
    proposalReferee.refereeFinalRecommend === null ||
    proposalReferee.refereeFinalRecommend === undefined ||
    proposalReferee.refereeFinalRecommend === "" ||
    proposalReferee.refereeFinalRecommend === 0
  )
    return false;
  if (
    proposalReferee.noteForAdvisors === null ||
    proposalReferee.noteForAdvisors === undefined ||
    proposalReferee.noteForAdvisors === ""
  )
    return false;

  return true;
};

const ProposalRow = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const loading = useLoading();
  const history = useHistory();
  const { proposalReferee } = props;
  const [proposalRefereeOpen, setProposalRefereeOpen] = useState(false);
  const [proposalRefereeDone, setProposalRefereeDone] = useState(false);

  const proposalSelected = (referee) => {
    const refereeStatus = checkRefereeStatus(referee);
    dispatch(
      setReferee({
        id: referee.itemID,
        idName: referee.proposalIdNumber,
        title: referee.proposalTitle,
        program: referee.proposalProgramtypeName,
      })
    );
    dispatch(setRefereeStatus(refereeStatus));
    dispatch(setCanEdit(true));
    history.push("./detailedevaluation");
  };

  const createPDF = async () => {
    const proposalId = proposalReferee.proposalId;
    if (!Boolean(proposalId)) return;
    const loadingId = loading.addLoading("Downloading Proposal Info");
    const pdfPath = await service.createProposalPDF({ proposalId });
    await service.downloadRawFile({
      path: pdfPath,
      filename: proposalReferee.proposalName,
    });
    loading.removeLoading(loadingId);
  };

  const openCloseSuggestedReviewers = () => {
    setProposalRefereeOpen(!proposalRefereeOpen);
  };

  useEffect(() => {
    const status = checkProposalRefereeStatus(proposalReferee);
    setProposalRefereeDone(status);
  }, [proposalReferee]);

  return (
    <>
      <Modal open={proposalRefereeOpen}>
        <Box>
          <SuggestedReviewer
            proposalId={proposalReferee?.proposalId}
            openCloseSuggestedReviewers={() => setProposalRefereeOpen(false)}
          />
        </Box>
      </Modal>
      <TableRow>
        <TableCell
          className={classes.proposalName}
          onClick={() => proposalSelected(proposalReferee)}
        >
          <Link>{proposalReferee.proposalName}</Link>
        </TableCell>
        <TableCell>
          <IconButton color="primary" onClick={createPDF} size="large">
            <CloudDownloadIcon />
          </IconButton>
        </TableCell>
        <TableCell>{proposalReferee.proposalTitle}</TableCell>
        <TableCell>{proposalReferee.proposalProgramtypeName}</TableCell>
        <TableCell>
          {!proposalRefereeDone ? (
            <Chip
              className={classes.inProgressChip}
              size="small"
              label="IN PROGRESS"
              color="primary"
            />
          ) : (
            <Chip
              className={classes.doneChip}
              label="DONE"
              size="small"
              color="primary"
              icon={<DoneIcon fontSize="small" />}
            />
          )}
        </TableCell>
        <TableCell>
          <Button
            disableElevation
            variant="contained"
            size="small"
            className={classes.addButton}
            onClick={openCloseSuggestedReviewers}
            disabled={proposalRefereeOpen}
          >
            + Add
          </Button>
        </TableCell>
      </TableRow>
    </>
  );
};

export default function MyEvaluations(props) {
  const classes = useStyles();
  const { proposalReferees } = props;
  const tableHeaders = [
    { label: "Proposal ID" },
    { label: "View PDF" },
    { label: "Proposal Title" },
    { label: "Program" },
    { label: "Review Status" },
    { label: "Reviewers" },
  ];

  return (
    <>
      <Typography fontWeight={600} color="#4B4B4B"> Proposal I Accepted to Review </Typography>
      <Divider />

      <Table
        stickyHeader
        className={classes.table}
        size="small"
        aria-label="caption table"
      >
        <TableHead>
          <TableRow>
            {tableHeaders.map((header) => (
              <TableCell
                className={classes.tableCell}
                key={header.label}
                align="left"
                style={{ width: header.size }}
              >
                {header.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {proposalReferees.map((proposalReferee) => (
            <ProposalRow
              key={proposalReferee.itemID}
              proposalReferee={proposalReferee}
            />
          ))}
        </TableBody>
      </Table>
    </>
  );
}
